/**
 * @author: subhasish.ghosh@zoom.us
 */

import { Box, Grid, Typography } from "@mui/material";
import React from "react";

const PendingCancellationsHeader = ({
  total,
  totalMRR,
  days,
  boundaryDays,
}) => (
  <Box sx={{ padding: 2 }}>
    <Grid container spacing={2} className="responsive-container">
      <Grid
        item
        xs={4}
        style={{ maxWidth: "15%" }}
        className="responsive-item-pending-days"
      >
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Total
          </Typography>
          <Typography
            variant="h4"
            component="div"
            style={{ fontWeight: "bold" }}
          >
            {total}
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={4}
        style={{ minWidth: "40%" }}
        className="responsive-item-pending-days"
      >
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Total Gross MRR
          </Typography>
          <Typography
            variant="h4"
            component="div"
            style={{ fontWeight: "bold" }}
          >
            {`$${totalMRR}`}
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={4}
        style={{ minWidth: "40%" }}
        className="responsive-item-pending-days"
      >
        <Box sx={{ textAlign: "left" }}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            {`Due for Cancel In < ${boundaryDays} days`}
          </Typography>
          <Typography
            variant="h4"
            component="div"
            style={{ fontWeight: "bold" }}
          >
            {days}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default PendingCancellationsHeader;
